import { render, staticRenderFns } from "./FileAttachItem.vue?vue&type=template&id=b8ed940c&scoped=true&"
import script from "./FileAttachItem.vue?vue&type=script&lang=js&"
export * from "./FileAttachItem.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=b8ed940c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ed940c",
  null
  
)

export default component.exports